import { Flex, Link } from "@chakra-ui/react";
import { SocialFacebook, SocialTwitter, SocialInstagram, SocialLinkedin } from "@airhelp/icons";
import { useLanguage } from "contexts/LocalizationContext";
import { getSocialLink } from "utils/socialUtils";

const QA_ATTRIBUTE = "footer-share-button";

const SocialIcons = () => {
  const language = useLanguage();

  return (
    <Flex mt={{ base: 8, xl: 16 }} data-testid="social-icons">
      <Link
        isExternal
        aria-label="Redirect to facebook"
        href={getSocialLink(language, "facebook")}
        data-testid={QA_ATTRIBUTE}
        rounded="sm"
      >
        <SocialFacebook color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to twitter"
        href={getSocialLink(language, "twitter")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
        rounded="sm"
      >
        <SocialTwitter color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to instagram"
        href={getSocialLink(language, "instagram")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
        rounded="sm"
      >
        <SocialInstagram color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to linkedin"
        href={getSocialLink(language, "linkedin")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
        rounded="sm"
      >
        <SocialLinkedin color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" rounded="sm" />
      </Link>
    </Flex>
  );
};

export default SocialIcons;
